var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemains14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 750",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svetlejsi"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000151513812946523858880000001590365851067066009_",
    d: "M0 0h750v750H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170267142611901164940000015859365775441416589_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000151513812946523858880000001590365851067066009_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)",
    fill: "#FAFAFA",
    d: "M-19-21.5h798.4v671.3H-19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.1 528.7s-39.3-16.6-43-16.6c-3.7 0-25.4 2.9-25.4 2.9s-35.2-8.6-38.1-10.7c-2.9-2.2-34.4-2.4-36.6-2.4-2.2 0-25.7 5.9-30.8 6.6s-24.2 2.2-26.4.7c-2.2-1.5-17.6-3.7-22-2.2-4.4 1.5-22.7 1.5-22.7 1.5s-8.8-1.5-13.2-4.4c-4.4-2.9-13.9-6.6-18.3-5.9s-9.5 9.5-17.6 10.3c-8.1.7-27.1.7-27.1.7s-22.7-7.3-30.8-2.9-26.4 11-30.8 13.2c-4.4 2.2-26.4 2.2-26.4 2.2s-11.7 2.2-14.7.7-15.4-8.1-17.6-9.5c-2.2-1.5-10.3-4.4-13.9-5.1-3.7-.7-17.6-8.1-17.6-8.1s-8.8-2.9-11-2.9-24.9 0-28.6-2.2c-3.7-2.2-27.9-6.6-27.9-6.6s-9.5-7.3-11-9.5-12.5-8.1-12.5-8.1-16.9-5.1-19.1-7.3c-2.2-2.2-14.7-5.1-14.7-5.1l-11.7 8.8s-12.5 7.3-15.4 8.1-22.7-4.4-22.7-4.4l-5.9-6.6-9.5-1.5-21.1 11.5-13.2 2.9-7.3 8.1-12.5 4.4-16.9 4.4-8.8 7.3-25.7 2.2-15.2 8.8-18.4 5.9-40.3 12.5v164.4L812.1 728l2-199.3z",
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-86.9 564.1l19.4-13.4s19 1.3 30.1.1c4.4-.5 12.1-1.9 19.7-3.4l10.9 7.7 30 1.8 15.7 5.7 22.1 14 22 7.9 9.6 20.9 72.5-11.4 24.2-10.3 16.1 3.7 27.1-5.9 16.1 9.5 26.4 5.9 32.1 28.8 24.3 8.7 12.8-3.3 18.9-6.5 13.9-7.7 23.1-3.2 12.3-7.9c10.2-1.6 22-4.7 24.5-6.4 3-2.1 9.6-1.9 9.6-1.9s25.1-5.9 37-12.1c11.9-6.3 13.3-4 20-6 6.7-2 11.5-16.5 13-18.7 1.5-2.2 22.3-11.8 27.5-13.2 5.2-1.3 14.9-9.1 20.9-11.9s22.7 1.4 22.7 1.4 22.7 1.4 29.3.8c6.6-.5 17.7-4.6 23.6-5.9 5.9-1.3 8.9-1.9 12.5-1.8 3.7.1 16.1 1.2 16.1 1.2s10.7 9.1 18.1 7.8c7.4-1.3 30.5 11.1 44.3 16.7 13.8 5.5 22.7 1.4 22.7 1.4s12.5-2.6 16.2-1.7c3.6.8 21 10.1 24.6 11 3.6.8 19.6 5.7 24 6.5 4.4.9 20.5 1.3 26.4 1.5 5.9.2 9-7.1 14.1-7.7 5.1-.6 10.1 5.4 15.2 5.6 5.1.1 13.2.4 15.4 1.2 2.2.8 25.1 18.3 25.1 18.3l-6.1 213.9L-104.6 777l5.7-200.7 12-12.2z",
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M132.6 598.6l.3 1.7h-1.4v-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.4 598.6l-.3 1.7h1.4v-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M131.5 589.9l-6.8 9.3 4.4-1.1 2.4 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M131.5 586.8l-5.8 7.9 3.8-.9 2 .8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M131.5 584.8l-4.3 5.8 2.8-.7 1.5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M131.5 589.9l6.9 9.3-4.5-1.1-2.4 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M131.5 586.8l5.8 7.9-3.8-.9-2 .8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M131.5 584.8l4.3 5.8-2.8-.7-1.5.7z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M45.6 585.3l.4 1.7h-1.5v-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4 585.3l-.3 1.7h1.4v-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M44.5 576.5l-6.8 9.4 4.5-1.2 2.3 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M44.5 573.5l-5.7 7.9 3.7-1 2 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M44.5 571.4l-4.3 5.9 2.8-.7 1.5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M44.5 576.5l6.9 9.4-4.5-1.2-2.4 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M44.5 573.5l5.8 7.9-3.8-1-2 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M44.5 571.4l4.3 5.9-2.8-.7-1.5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M33.2 581.3l.3 1.7h-1.4v-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 581.3l-.4 1.7h1.5v-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M32.1 572.5l-6.9 9.4 4.5-1.2 2.4 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M32.1 569.5l-5.8 7.9 3.8-1 2 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M32.1 567.4l-4.3 5.9 2.8-.7 1.5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M32.1 572.5l6.8 9.4-4.5-1.2-2.3 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M32.1 569.5l5.8 7.9-3.8-1-2 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M32.1 567.4l4.3 5.9-2.8-.7-1.5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M16 585.4l.3 1.4H15v-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1 585.4l-.3 1.4H15v-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M15 577.8l-5.9 8.1 3.9-1 2 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M15 575.2l-5 6.8 3.3-.9 1.7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M15 573.4l-3.7 5.1 2.4-.7 1.3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M15 577.8l5.9 8.1-3.8-1-2.1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M15 575.2l5 6.8-3.3-.9-1.7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M15 573.4l3.7 5.1-2.4-.7-1.3.6z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M116.2 593l.4 1.7h-1.5V593z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 593l-.3 1.7h1.4V593z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M115.1 584.2l-6.8 9.4 4.5-1.1 2.3 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M115.1 581.2l-5.7 7.9 3.7-1 2 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M115.1 579.1l-4.3 5.9 2.8-.7 1.5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M115.1 584.3l6.9 9.3-4.5-1.1-2.4 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M115.1 581.2l5.8 7.9-3.8-1-2 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M115.1 579.1l4.3 5.9-2.8-.7-1.5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M321.7 613.6l.4 1.7h-1.5v-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.5 613.6l-.3 1.7h1.4v-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M320.6 604.8l-6.8 9.4 4.4-1.2 2.4 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M320.6 601.8l-5.8 7.9 3.8-1 2 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M320.6 599.7l-4.3 5.9 2.8-.7 1.5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M320.6 604.8l6.9 9.4-4.5-1.2-2.4 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M320.6 601.8l5.8 7.9-3.8-1-2 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M320.6 599.7l4.3 5.9-2.8-.7-1.5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M304.6 617l.4 1.7h-1.5V617z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.4 617l-.3 1.7h1.4V617z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M303.5 608.2l-6.8 9.4 4.4-1.1 2.4 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M303.5 605.2l-5.8 7.9 3.8-1 2 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M303.5 603.1l-4.3 5.9 2.8-.7 1.5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M303.5 608.2l6.9 9.4-4.5-1.1-2.4 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M303.5 605.2l5.8 7.9-3.8-1-2 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M303.5 603.1l4.3 5.9-2.8-.7-1.5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M695.3 682.5l.4 2.1h-1.8v-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.5 682.5l-.4 2.1h1.8v-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M693.9 671.4l-8.7 11.8 5.7-1.4 3 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M693.9 667.6l-7.3 9.9 4.8-1.2 2.5 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M693.9 665l-5.4 7.4 3.5-.9 1.9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M693.9 671.4l8.6 11.8-5.6-1.4-3 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M693.9 667.6l7.3 9.9-4.8-1.2-2.5 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M693.9 665l5.4 7.4-3.5-.9-1.9.8z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M673.7 686.8l.4 2.1h-1.8v-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671 686.8l-.5 2.1h1.8v-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M672.3 675.7l-8.6 11.8 5.6-1.4 3 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M672.3 671.9l-7.2 9.9 4.7-1.2 2.5 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M672.3 669.3l-5.4 7.4 3.6-.9 1.8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M672.3 675.7l8.7 11.8-5.7-1.4-3 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M672.3 671.9l7.3 9.9-4.7-1.2-2.6 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M672.3 669.3l5.5 7.4-3.6-.9-1.9.8z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M614.1 684.3l.4 2.2h-1.8v-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.4 684.3l-.5 2.2h1.8v-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M612.7 673.3l-8.6 11.8 5.6-1.5 3 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M612.7 669.5l-7.2 9.9 4.7-1.2 2.5 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M612.7 666.9l-5.4 7.4 3.5-.9 1.9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M612.7 673.3l8.7 11.8-5.7-1.5-3 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M612.7 669.5l7.3 9.9-4.8-1.2-2.5 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M612.7 666.9l5.5 7.4-3.6-.9-1.9.8z"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)",
    fill: "#AFAFAF",
    d: "M1027.1 717.3L954.2 695l-32.2 2.2-31.5-15.4-35.2-3.6-17.6-11H826l-3-.8-5.1-5.8-15.8-7.8-22-1.5-19 13.2-20.6 4.4-13.5 4.9-11.4-5.7-13.5 7.9-8.1 4.4-21.9.7-20.6-4.4-43.9 5.1-24.2 5.2-30.8-1.5-26.4-11-25.6-9.5h-33.8l-14.6-11.8-18.3-7.3-14-5.1-10.9-7.3-22-3.7-27.9-13L344 619l-16.8-7.3h-19.8l-19.4 7.8-19.8 1.5-15.4-4.9-15.3 8.6-24.2 5.1h-2.2l-12.2-9.3-13.2 2-16.6-11.8-26.4-10.7-14.1-5.9-28.2-5.3-13.2-8.1-18.4 6.3-31.8-8.3-22.4 4.2-18.3 8.8-29.3 5.8-5.9 5.2-27.8 14.6-5.9 14-19.8 7.3-13.1 8-12.5 8.8-14.7 9.6-22 18.3.4 147.3h1182.4z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M54.2 701.5l1.6 7.7h-6.5v-7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 701.5l-1.6 7.7h6.4v-7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M49.3 662.3l-30.6 41.9 20-5.1 10.6 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M49.3 648.7L23.5 684l16.9-4.3 8.9 3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M49.3 639.4l-19.2 26.3 12.6-3.2 6.6 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M49.3 662.3L80 704.2l-20-5.1-10.7 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M49.3 648.7L75.2 684l-16.9-4.3-9 3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M49.3 639.4l19.3 26.4-12.6-3.3-6.7 2.9z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M119.4 740.5l1.9 9.7h-7.6v-9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.9 740.5l-1.8 9.7h7.6v-9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M113.7 690.9l-36.3 53 23.7-6.5 12.6 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M113.7 673.7l-30.6 44.7 20-5.5 10.6 4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M113.7 662l-22.8 33.3 14.9-4.1 7.9 3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M113.7 690.9l36.2 53-23.7-6.5-12.5 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M113.7 673.7l30.5 44.7-19.9-5.5-10.6 4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M113.7 662l22.8 33.3-14.9-4-7.9 3.6z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M67.8 719.9l-30.7 42 20.1-5.2 10.6 4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M67.8 706.3l-25.9 35.4 16.9-4.4 9 3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M67.8 697.1l-19.3 26.3 12.6-3.2 6.7 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M67.8 719.9l30.7 42-20.1-5.2-10.6 4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M67.8 706.3l25.8 35.4-16.9-4.4-8.9 3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M67.8 697.1l19.3 26.3-12.6-3.2-6.7 2.9z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M253.5 679.6l1.2 6h-5v-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.8 679.6l-1.2 6h5.1v-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M249.7 648.8l-24.2 32.9 15.8-4 8.4 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M249.7 638.1l-20.4 27.8 13.3-3.4 7.1 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M249.7 630.8l-15.2 20.7 9.9-2.5 5.3 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M249.7 648.8l24.1 32.9-15.8-4-8.3 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M249.7 638.1l20.3 27.8-13.3-3.4-7 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M249.7 630.8l15.1 20.7-9.9-2.5-5.2 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M211.4 736.3l1.5 7.6h-6.4v-7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.6 736.3l-1.5 7.6h6.4v-7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M206.5 697l-30.7 41.9 20.1-5.1 10.6 4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M206.5 683.4l-25.9 35.3 16.9-4.3 9 3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M206.5 674.1l-19.3 26.4 12.6-3.2 6.7 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M206.5 697l30.7 41.9-20.1-5.1-10.6 4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M206.5 683.4l25.9 35.3-17-4.3-8.9 3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M206.5 674.2l19.3 26.3-12.6-3.2-6.7 2.8z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M281.7 749.4l1.5 7.6h-6.4v-7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.9 749.4l-1.5 7.6h6.4v-7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M276.8 710.1L246.1 752l20.1-5.1 10.6 4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M276.8 696.5l-25.9 35.3 16.9-4.3 9 3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M276.8 687.2l-19.3 26.4 12.6-3.2 6.7 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M276.8 710.1l30.7 41.9-20.1-5.1-10.6 4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M276.8 696.5l25.9 35.3-17-4.3-8.9 3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M276.8 687.3l19.3 26.3-12.6-3.2-6.7 2.8z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M156.7 723.3l-24.1 33 15.8-4 8.3 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M156.7 712.7l-20.3 27.7 13.3-3.4 7 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M156.7 705.4l-15.2 20.7 10-2.5 5.2 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M156.7 723.4l24.1 32.9-15.7-4-8.4 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M156.7 712.7l20.3 27.7-13.2-3.4-7.1 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M156.7 705.4l15.2 20.7-9.9-2.5-5.3 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M417.8 713.6l1 4.8h-4.1v-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.6 713.6l-1 4.8h4.1v-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M414.7 688.6l-19.5 26.7L408 712l6.7 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M414.7 680l-16.4 22.4 10.7-2.7 5.7 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M414.7 674.1l-12.2 16.7 8-2 4.2 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M414.7 688.6l19.5 26.7-12.8-3.3-6.7 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M414.7 680l16.4 22.4-10.7-2.7-5.7 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M414.7 674.1l12.3 16.7-8.1-2-4.2 1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M240.8 734l-24.1 33 15.8-4 8.3 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M240.8 723.3l-20.3 27.8 13.3-3.4 7 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M240.8 716l-15.1 20.8 9.9-2.6 5.2 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M240.8 734l24.1 33-15.7-4-8.4 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M240.8 723.3l20.4 27.8-13.3-3.4-7.1 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M240.8 716l15.2 20.8-9.9-2.6-5.3 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M304.1 719.4L280 752.3l15.8-4 8.3 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M304.1 708.7l-20.3 27.8 13.3-3.4 7 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M304.1 701.4L289 722.1l9.9-2.5 5.2 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M304.1 719.4l24.2 32.9-15.8-4-8.4 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M304.1 708.7l20.4 27.8-13.3-3.4-7.1 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M304.1 701.4l15.2 20.7-9.9-2.5-5.3 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M19.8 625.9l.7 3.6h-3v-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2 625.9l-.7 3.6h3v-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M17.5 607.7L3.2 627.2l9.4-2.4 4.9 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M17.5 601.4l-12 16.4 7.8-2 4.2 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M17.5 597.1l-9 12.2 5.9-1.5 3.1 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M17.5 607.7l14.2 19.5-9.3-2.4-4.9 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M17.5 601.4l12 16.4-7.8-2-4.2 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M17.5 597.1l9 12.2-5.9-1.5-3.1 1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M68.1 619.4l.5 2.5h-2.1v-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 619.4l-.5 2.5h2v-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M66.5 606.8l-9.8 13.5 6.4-1.7 3.4 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M66.5 602.4l-8.3 11.4 5.4-1.4 2.9 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M66.5 599.5l-6.2 8.4 4.1-1 2.1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M66.5 606.8l9.9 13.5-6.5-1.7-3.4 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M66.5 602.4l8.3 11.4-5.4-1.4-2.9 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M66.5 599.5l6.2 8.4-4-1-2.2.9z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M316.3 640.4l.5 2.5h-2.1v-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.2 640.4l-.5 2.5h2v-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M314.7 627.8l-9.8 13.5 6.4-1.7 3.4 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M314.7 623.4l-8.3 11.4 5.5-1.4 2.8 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M314.7 620.5l-6.2 8.4 4.1-1 2.1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M314.7 627.8l9.9 13.5-6.5-1.7-3.4 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M314.7 623.4l8.3 11.4-5.4-1.4-2.9 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M314.7 620.5l6.2 8.4-4-1-2.2.9z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M85.2 602.9l.3 1.7h-1.4v-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 602.9l-.3 1.7h1.4v-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M84.1 594.1l-6.9 9.4 4.5-1.2 2.4 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M84.1 591.1l-5.8 7.9 3.8-1 2 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M84.1 589l-4.3 5.9 2.8-.7 1.5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M84.1 594.1l6.9 9.4-4.5-1.2-2.4 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M84.1 591.1l5.8 7.9-3.8-1-2 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M84.1 589l4.3 5.9-2.8-.7-1.5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M158.8 646.1l.8 3.8h-3.2v-3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 646.1l-.8 3.8h3.2v-3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M156.4 626.6l-15.2 20.8 10-2.6 5.2 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M156.4 619.8l-12.8 17.6 8.4-2.2 4.4 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M156.4 615.2l-9.5 13.1 6.2-1.6 3.3 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M156.4 626.6l15.3 20.8-10-2.6-5.3 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M156.4 619.8l12.9 17.6-8.4-2.2-4.5 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M156.4 615.2l9.6 13.1-6.3-1.6-3.3 1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M356.2 668.1l.6 2.9h-2.4v-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.5 668.1l-.5 2.9h2.4v-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M354.4 653.2l-11.7 15.9 7.7-1.9 4 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M354.4 648.1l-9.8 13.4 6.4-1.7 3.4 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M354.4 644.5l-7.3 10 4.8-1.2 2.5 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M354.4 653.2l11.6 15.9-7.6-1.9-4 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M354.4 648.1l9.8 13.4-6.4-1.7-3.4 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M354.4 644.6l7.3 10-4.8-1.3-2.5 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M358.7 734.3l-27.3 37.3 17.9-4.6 9.4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M358.7 722.2l-23 31.4 15.1-3.9 7.9 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M358.7 713.9l-17.1 23.5 11.2-2.9 5.9 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M358.7 734.3l27.3 37.3-17.9-4.6-9.4 4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M358.7 722.2l23 31.4-15-3.8-8 3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M358.7 713.9l17.1 23.5-11.2-2.9-5.9 2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M21.7 690.5l-50.6 69.1 33.1-8.4 17.5 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M21.7 668.1L-21 726.3l27.9-7.1 14.8 6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M21.7 652.8l-31.8 43.5 20.8-5.3 11 4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M21.7 690.5l50.5 69.1-33-8.4-17.5 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M21.7 668.1l42.6 58.2-27.9-7.1-14.7 6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M21.7 652.8l31.8 43.5-20.8-5.3-11 4.7z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 600.6,
    cy: 232.1,
    r: 99.7,
    clipPath: "url(#SVGID_00000170267142611901164940000015859365775441416589_)",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemains14);
export default __webpack_public_path__ + "static/media/remains_14.dc03ab04edd120bff8695652f4354167.svg";
export { ForwardRef as ReactComponent };